import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import redirectIfNotLoggedIn from './stores/redux/redirectIfNotLoggedIn';
var store = configureStore({
    reducer: rootReducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware().concat(redirectIfNotLoggedIn);
    },
    preloadedState: {},
});
export default store;
